import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/1168a418/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "basic-data-table"
    }}>{`Basic data table`}</h2>
    <p>{`The data table component is designed in a way for additional functionality to be added on to fit your team’s needs.`}</p>
    <p>{`The basic data table is shipped with a base style, which includes:`}</p>
    <ul>
      <li parentName="ul">{`Borders`}</li>
      <li parentName="ul">{`No zebra striping, row dividers instead.`}</li>
      <li parentName="ul">{`No Pagination, search, table toolbar, or multi-select`}</li>
    </ul>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "72.82608695652173%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAACEElEQVQ4y61UuW4bMRRk6H9LkZ8wXDg/oEZqVKX0d+gPnC1lbRkJAiTohE4Iuu/7WmpfZqjdNZzCSGECg8djOBw+vl2l0FKplEomkyqRSKhYLKbS6bS63W5qvV6r7Xb7X2AL45e0D2Kz2ezXeDzOjEajV8BZLpfO4XBwdrudA+Jn+A2kge+BqLaCEMksFgvpdrvS6/VktVrJ6XQSz/Pks+b7vo37/f6ZOogPVnAymbzCjczn8wtg4NjAscFBZjqdWnDMNXDtGBwP/ctmsxH0H4Ob3gULhYJTr9el1WqZZrMpIXK5nBSLRanVapLP56Xdbgu4Ui6X2fez2azldzqdJ+qg/xDm0OFJw+GQJwteV5BHgSsb4YwuhBzOwRk5PvnIG1NkBZG2uyAWnfP5zI2GYrw+iRRj5ByBHNk5AhyffO4DxwriwLsgTnCOx6MwN6EI3WBsIx8pELFOCXB88rkPnKdA510QZcKrRIIEBSlGd4x0GF6fDkPB0CF4kaB9ZRAuEGReDE61r8qIdQsImrAKwPcQL0F6Hj8IQiTDeuL1rtdrVGOsRXyCYoyJapJzdMVGMTYI/vzX4QtOy8HhG/ouiC5ILuZckCw4D4cuHNp5chDfMP4D7o/gUbSKx+Nf8i3zRxI11NO3UqmkUcS63+9rONEg6EqlouHaYjAYaJSIbjQaulqtalzbrqOYdfhjgGP1F5J+NWopx8SQAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "basic data table",
          "title": "basic data table",
          "src": "/static/786fc67ab286a09696016dbdb2133ad9/fb070/data-table-usage-1.png",
          "srcSet": ["/static/786fc67ab286a09696016dbdb2133ad9/d6747/data-table-usage-1.png 288w", "/static/786fc67ab286a09696016dbdb2133ad9/09548/data-table-usage-1.png 576w", "/static/786fc67ab286a09696016dbdb2133ad9/fb070/data-table-usage-1.png 1152w", "/static/786fc67ab286a09696016dbdb2133ad9/c3e47/data-table-usage-1.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Basic data table</Caption>
    <h2 {...{
      "id": "additional-functionality"
    }}>{`Additional functionality`}</h2>
    <p>{`The following can be added to the data table to increase its functionality.`}</p>
    <h3 {...{
      "id": "pagination"
    }}>{`Pagination`}</h3>
    <p>{`Pagination divides table data into separate pages. Pagination is accompanied by an option that enables the user to change the number of items per page. See the `}<a parentName="p" {...{
        "href": "/components/Pagination"
      }}>{`pagination`}</a>{` component for further guidelines.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "105.43478260869566%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAVCAYAAABG1c6oAAAACXBIWXMAAAsSAAALEgHS3X78AAACPElEQVQ4y61Uy47TQBB0vPwGv8ABaQ+7IHHnMzjBXjjxA/wZQqAFH7ggLlyQopCHY8d2nKfHM1R1pp1xIgS72pEqPe6Zqe7p6kkUYTjn3rjDMID1c2et/ReM35cAjyId+Ljhwmq1MpvNxtZ1LQf+YxhvE+BIiA8hnE6nJs9zIVyv1wzgFouFQxABfUSWZbIGnxDC189QrzybzQwIbFVVrixLVxSFm8/nMg+RpqkEwj7TNA19CXBOiI0Gm+xyuXSEEnLOIGrp4xq+DQZ9CdAn5MJoNDKABZhtd3gymcg1mRntcDiUObIy+/2e2Z7V8DUzxCI3WF6DAQgeIOhT7HY79UkNYfs1bNv2LRe2222DzVZFwPe9VX6GeixYF1yzpYIE1SZIHIKl8AGNT6RPyIF2+UQS1IjCyCEG0FqGKtPng3cqI6Fehhcg+kIVWei/qazQtlGVYfuESDkG0S0LTcLTvgtBcqpOIKChQLjdWQ1jRLr1iklUXkUVDkE/68gasit8dyQ4cyRETWI8n46QUUl677cMErkySfgHAbB12I9i2ZshkKHOuwxPrzzIsvxzUcg7bVAnPj/Ld43s+bYtAnYYj8fWv/nG152CXvQI8yz7utuuXY2ia7/xn4VKn/YhFdZ/JA4QfwvespPfH7/Kpx++Vy9/DssXdVVcocuvQXaN6GJDQFWdXwHPgSfYd6C7fN9GDzWQ5WHy+J3DtX8PnPsImw7GaRXXy5JCxYguNgQyPPUPugyjV+5oFeH3HccfjKbxX4Fu1DgAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "data table with pagination",
          "title": "data table with pagination",
          "src": "/static/d0132152e185afb3320e0999581f5799/fb070/data-table-usage-2.png",
          "srcSet": ["/static/d0132152e185afb3320e0999581f5799/d6747/data-table-usage-2.png 288w", "/static/d0132152e185afb3320e0999581f5799/09548/data-table-usage-2.png 576w", "/static/d0132152e185afb3320e0999581f5799/fb070/data-table-usage-2.png 1152w", "/static/d0132152e185afb3320e0999581f5799/c3e47/data-table-usage-2.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Data table with various Pagination methods</Caption>
    <h3 {...{
      "id": "search"
    }}>{`Search`}</h3>
    <p>{`Search returns results based on matches. It is used to locate and display a set of results. Search functionality within a table follows `}<a parentName="p" {...{
        "href": "/components/search"
      }}>{`small search`}</a>{` conventions. Search should be closed by default, and live below the table title.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "155.70652173913044%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAAAsSAAALEgHS3X78AAADp0lEQVRIx62VXW4bNxDH5TrPBVygB8gN+paHNsgdeoiqD71BXnqSFs5Lb9AbtLYlu1IjxfqWtatvyZasXUm2tFyyv2F2CRlyUKc1gT9mZ0gO/zucGWYyzziCIMhk4jg+MMZYzOfzgzAMD5j4L/joVWt9grOT9Xp9gvFPHFr5b2CdyD9AAfyyXC4PrUOzM5RSn4Xtdmv34bx0c3PzImWoxBcMFRNPBowUzLb39/eGUJ3i4zB1mJ4iEw63t7cWn7KJvL6+FsdmOBzm9hx2u11Tq9VMs9k0jUbDnJ+fm0Kh4HSRoou9Xq9bHah+v29arVauVCo5hzH+YugrOXE2mynioQaDgRqNRk4XCRNrT3XkRhgiT2G9fynpENar1cpIfHbH3d2dIdYm/Su5mCRcZfAiddhlgc9JxcVikYNpHpmfTCZ5GOdTXeR0OrV20ROcgTI4Bh8ZktiHLqD/c8DSxvAVDl/xi9/C4jXG70RyIgheB0HoILrYZT6xsTZ8w55vkJm9GEZR5JI2fgK2243dxwHvV8uli6FNbBhKoqoQcJqaL5Y7CNXs9lFQLJEh/mfD0dSljVyZ5gY11PV6vdL+aKFr7YFuXA10rdXTTW+kW/5Yt7sTfdWbJN9jXb8aqd50beazm/3E5kZJ7h5ZPzC1VtecXlyafLFiih+a5n2lbUrVjvmrVDfnf9ecXrxsq5Y/Mb7v5SaBfsiQpNXtdlt3PE97Xkd/KJd1tVLR3a6vfWy+7+vK5aUuY/c6HXSxeWo6nRjP83LNRt0ldoTPyMWQwhdJzlEJMxUkutilQqSagiTO0hyk4xD30zB8pH2Rk7YKREpFSKWkusi0UkQXSFYkt1wG7pbfsvgtDH4ix7LgRzpJlhBkqYosC8Vm5Xg8zlLfWZlP1v4AZN/34CDz3MM+A7B7B8t3/MoxhmOYWvlE/Ap+Az+z74tPdpvPHTir8MvuCZDIRjCMOCliMmIy4kYt6HsRvc5hV+f7Xi6J9SebzebhLUv/Y8I+BZLk0qWr1arpdDpGunKv1zM0Vwv5Fhu5qeQp4LL2K0UWiBOS27b3x56AYrFoLi4u3BOA3T0B2B4+AfxCTErEpErMiTFvTMxiq6eAmbXLfGLbEiZheMb3w1+WjCcOTsqvyO/v2mWzhCXVJdFl0G0Ky532NYflHMOQxX029UVyYp9YWj0F5Wjt6TrQBXPwO3AMX+LwJWy+ZsMRTo643SNCcMQtWj2F2AS7NvAV+BI8e6FkxOk/PIJL8ZoFbNUAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "data table with search",
          "title": "data table with search",
          "src": "/static/aac2fd77a84147a8ae1a58ddd90d7884/fb070/data-table-usage-3.png",
          "srcSet": ["/static/aac2fd77a84147a8ae1a58ddd90d7884/d6747/data-table-usage-3.png 288w", "/static/aac2fd77a84147a8ae1a58ddd90d7884/09548/data-table-usage-3.png 576w", "/static/aac2fd77a84147a8ae1a58ddd90d7884/fb070/data-table-usage-3.png 1152w", "/static/aac2fd77a84147a8ae1a58ddd90d7884/c3e47/data-table-usage-3.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Search on data tables.</Caption>
    <h3 {...{
      "id": "sorting"
    }}>{`Sorting`}</h3>
    <p>{`Improve table usability by making data sortable. Clickable headers enable users to sort table data up or down. The specific attribute being sorted is accompanied by a caret icon. The caret will only appear on the column headers once that particular column is being sorted. You can see a demo of this on Carbon’s `}<a parentName="p" {...{
        "href": "https://codepen.io/tjegan/pen/PjjyVN"
      }}>{`Codepen.`}</a></p>
    <h3 {...{
      "id": "table-toolbar"
    }}>{`Table toolbar`}</h3>
    <p>{`The table toolbar is reserved for global table actions such as table settings, complex filter, export, or editing table data. Additional options can be added if you have an icon to support that function. Icons should be 16x16 px (glyphs). We recommend using no more than 5 icons within the table toolbar.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.91847826086957%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABuUlEQVQoz62SS2sTYRSGJ1l0q26kVFy4cuG21J9UqFB3/oaALlxk72+QppCVySYNMTXmAmIiJMFJyOQyd8ZmMueb0/f7zHwQEnHTAy/vXM48854zYxgPUGEYGg9aO0BmrqZpWpUuhKjiZiUIgkrmmcIwqHh+WHE8rS9QDXopOfBcBtwpQLXwIi0hUnl3K4KSvw9Q8FpxKMhnQMIDsoMAISTT8n2fPM8j1/PpLvLp8+0fKlyt6WN5Te+v15sP5ZQLV/Gp5MA1UCVQLyNijMcAabmuy7bjIljE559ifvyG+MU7kT59S+LJJfOji0QB4fvAJEm42Wxyp9Ph8XjMSKcURRGnWIE5mXLtpsG1eiP92vwmfpsT/tkfKOBg8Gt/ZFnL5ZIWiwU5jiPHFTgWs9lMACoCrGA6ndB8btFqtdzgQ7FtrxQQnv/nR8kS27atBLi+HoQhx3GszmVh12fbX0cDe2jsSUfALvbWxh6/o6GLhBYSLwCcy/C41kfiFvbaxnELfT+gV5IDz//3hzVN8xh6NhwOT0aj0XPs9uhQH2CHAcVi0bAsy0CyHBIf7CmVSrl6vW5gbAPTaFjm9/dOONXGhAB/AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Table toolbar",
          "title": "Table toolbar",
          "src": "/static/0675b4f676975d0cf9e88e19eab010d9/fb070/data-table-usage-6.png",
          "srcSet": ["/static/0675b4f676975d0cf9e88e19eab010d9/d6747/data-table-usage-6.png 288w", "/static/0675b4f676975d0cf9e88e19eab010d9/09548/data-table-usage-6.png 576w", "/static/0675b4f676975d0cf9e88e19eab010d9/fb070/data-table-usage-6.png 1152w", "/static/0675b4f676975d0cf9e88e19eab010d9/c3e47/data-table-usage-6.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Table toolbar: table settings</Caption>
    <h3 {...{
      "id": "multi-select--batch-action"
    }}>{`Multi-select / batch action`}</h3>
    <p>{`Batch actions are functions that may be performed on multiple items within a table. Once the user selects at least one row from the table, the `}<strong parentName="p">{`batch action bar`}</strong>{` appears at the top of the table, presenting the user with actions they can take. To exit or escape “batch action mode,” the user can cancel out or deselect the items.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "85.86956521739131%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAACoklEQVQ4y61U224SYRCG6Ato1bTGRPsWvoEv4p021agXXtVoWjX6AE1M+gYapdHYuyaEtSWBJSzHFiiWBbocdheW4+6/Gb/5G6xbjN6U5Mucv5l/BgiFLvDT7/fPDCIKn0ckEgm32+3wcDgMI/l/CJLpDeNDTW+q1WM9Vj2uKx2zp9j9oWLazr8QA1Rgq2s5lwKEg25N9Udtsowjgk7kWkSih9AUEID3F3CMw32NqH/5N+HdtV54PTKNvd8hevvVdTcirnjxaSLWPo7FRmQi1r9MxcvPU/FmeypeQbL9elv63HffiVC7d39rejZh6IYTXlz1lOXnRMvPPLG06tKVBx5dfejR7aeCEKPrK9CfeHRtxaWbjzy69diF7ok7qEF+PHRvGnzyj1hUSakJ0tIpUa2U6OdRicqHBdrfU+igkKOslqJsRqNK6YA4r1I+pGI+I7KZNPvi/rgbJKzX64plmdRoNESz2aROp0O4MNXrOnW7XTo5OYGvLf3sY73VagnLNJHXioMjSGhaljIajcgwDAEQvgbkOI4kGAwGZFkW7IHUT+MO9Xo9wTm23Zsn5Alt2yZMJzClJGLMpsU0UvK0szheILgGcp4wGo0qmqZRKpUSyWSS8vk8FQoFUlWVisUiZTIZKRmJRELGAcEyl8vFPc8LEsZiMSWbzVI6nRYglWRczDpLjs0IucmMkG0mnEwmQcJKpaLwU8rlslcqlXzoPp7rV6tVHzvza7Waj8NIzOJYk6frOo5U3597MnYTF0IQ74QPwgcaj8fyMOhO+D1Lm4FjyDgfiGtgJ+cIsfRvmMRpnn4MXNUAuYGJpERDA4USmE76kMO5jmmaOwHCzc3NEKZYQPcldF5koLvEnzoDE5+PL0Eu4NKnZLu7uxf2f4hdhn4B6GWPuX0As4wAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Batch action mode",
          "title": "Batch action mode",
          "src": "/static/0fc0f85d31d627807b3bbfd228ffeb92/fb070/data-table-usage-7.png",
          "srcSet": ["/static/0fc0f85d31d627807b3bbfd228ffeb92/d6747/data-table-usage-7.png 288w", "/static/0fc0f85d31d627807b3bbfd228ffeb92/09548/data-table-usage-7.png 576w", "/static/0fc0f85d31d627807b3bbfd228ffeb92/fb070/data-table-usage-7.png 1152w", "/static/0fc0f85d31d627807b3bbfd228ffeb92/c3e47/data-table-usage-7.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Batch action mode on data tables</Caption>
    <h3 {...{
      "id": "inline-actions"
    }}>{`Inline actions`}</h3>
    <p>{`Inline actions are functions that may be performed on a specific table item. Each row is accompanied by an `}<a parentName="p" {...{
        "href": "/components/overflow-menu"
      }}>{`overflow menu`}</a>{` that contains actions related specifically to that table row.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "79.34782608695653%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAACI0lEQVQ4y62UzW7TQBSF4w0CFSEkYEGfhQeqsuEp2FB4B54BQTZsgtpFEYlVIbVR4kQJyJET/8Ue58exZ3w594YUQlJ105GOjsae+ebMzXVqtXsYSqm/EyJ6uFVVVY/gD1arVS1N01qWZbL4Lu1AAeizAGMfaK2v8fIMsHP4jmZJdh5vdAZdQB+hZ8yBW1vg3jDG7KmqDN7oPyo2C7VKoWPhaHUD5JWm2uwwZVkapNMsXFukVKqjONEfvq70+0au3zXy4rRR0unn3H37KX/JHPhuQgDFAaQkSQggms1m5AcBRVFAP90pvXqzphevK3paL81RnehJvfQen5QCPDopDwOXyyV1u13q9XrUbrep3++LBoMBXV1d08W37+Q4fTMajajnOJ7jOAKEHwYWRUEBUrFc16XxeEy+71MYhhT4Uzz7hXe+yVC+OAo9SIBRFN5+ZdRPxFDP86QE8/kcntJkOuW5yfM1yqI8SICpUrcD0SJSQ07F6RjIB7DzAXEcG/Qq19ibTCYCxOF3AxmGDfLjbIFTJIyiyKzXa14HvrcHlOYCUBxAtImSdkFCDYAG6KaNeI5DisViwYe6h4AHGxtfjNSNk3IavsG/6XnAUwCP/wdesrBBHJsusclmYZGNRDYS2khoY7/MoTbK8AO1/AJ/zhy4VbuvMRwOd/5tLBYSiqMPLaSx+MRWq2U1m00L/Wih4S2+VqfTsbiJURJ5hqYXDvpV/DeiNn2OMWEx+gAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Overflow menu example",
          "title": "Overflow menu example",
          "src": "/static/9bb5bb02c111a0431efd21e04d84fd27/fb070/data-table-usage-8.png",
          "srcSet": ["/static/9bb5bb02c111a0431efd21e04d84fd27/d6747/data-table-usage-8.png 288w", "/static/9bb5bb02c111a0431efd21e04d84fd27/09548/data-table-usage-8.png 576w", "/static/9bb5bb02c111a0431efd21e04d84fd27/fb070/data-table-usage-8.png 1152w", "/static/9bb5bb02c111a0431efd21e04d84fd27/c3e47/data-table-usage-8.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Overflow menu example</Caption>
    <p>{`When the overflow menu contains less than three options, keep the actions inline as icon buttons instead. This reduces 1 click and makes available actions visible to users at a glance.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "79.34782608695653%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAAB0ElEQVQ4y61TyW7CMBTEf9BKlF/vrb/Qa880BwoUgdgkNimEHcK+4/A6YymQBMoJSyP7vbw3nrGdWOyJY7lcXgMRuQFHpVKJnU6n2GKxMA2PECIbDofvg8Eg2+12k4A1n8+t9XptofARvoEf4BN4CRH2+/0sVIjjONLr9QQFst1uRWstHOfzWYKDsed5Zo2NXSARIqQyqBQQH6BU27ZtwDWBb7rT6eh2u32JMR8nk4lgthHHQ4Q4K6tarUqtVtONRkMKhYKUSiVpNpsGrVZLisWi5PN5qdfrft6jI8wOet5ChNPp1KJFnJ2mXe7suq6xTqxWKxMzH8h5s9lMoM5Bb5gQxbyEC+F4PI42m5j5ICHPfTQa3RKimLcm2NEQ4lyizSZm3s8BHgTcV0jLm83mX8tE1DIJfYXofWwZRXctMx+0TIV3LUNhkkUoOGDWsKdBQHIDNJuYeT8HHNFHQhuE8ajCXz7U/X5vHiwV8Qi4JviQGTPPx84cfkkDELogTEQJP/ChikvJYucc1jkoynGNczIzY+b9GMgiLuJSvrDZ64XsWQPKrwrx+lUqlVJ4FgqXozKZjMKfobCzgk212+0U/hyVTqcVlJkafiuXy6bOF/YH+7V6HTXsICAAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Inline actions without overflow",
          "title": "Inline actions without overflow",
          "src": "/static/9ee36ddb1e5d2e9286b85ec92a1dfe3a/fb070/data-table-usage-10.png",
          "srcSet": ["/static/9ee36ddb1e5d2e9286b85ec92a1dfe3a/d6747/data-table-usage-10.png 288w", "/static/9ee36ddb1e5d2e9286b85ec92a1dfe3a/09548/data-table-usage-10.png 576w", "/static/9ee36ddb1e5d2e9286b85ec92a1dfe3a/fb070/data-table-usage-10.png 1152w", "/static/9ee36ddb1e5d2e9286b85ec92a1dfe3a/c3e47/data-table-usage-10.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Overflow menu example</Caption>
    <h4 {...{
      "id": "persistent-overflow-menu"
    }}>{`Persistent overflow menu`}</h4>
    <p>{`By default, the overflow menu icon appears on hover or focus. This reduces visual clutter and drives user interactions with clear context and results.`}</p>
    <p>{`Data table also supports persistent overflow menu icons. Overflow icons should only persist if the actions contained within them are core to the function of your table. Enabling persistent overflow icons may complicate data presentation and impact general usability.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "79.34782608695653%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAABv0lEQVQ4y62U2W7CMBBF4z9oJcqv962/0Nc+0zxQoAgURCQ2KYQdwr7jML3XUmgDLUIqlq48M4yPZ2wHy7rjmM/n346IXIijXC5bh8PBms1mZsE1xWD9fv+51+vl2u12CrKn06m9XC5tJF7TO/QBvUIPMWC3282hCvF9XzqdjiBB1uu1aK2F43g8ys9BPwxDY2PjAErGgKwMVQrAO1SqPc8zok3hN91qtXSz2Tz5mPej0Ugwe/ATMSDOynZdVyqViq7ValIsFqVUKkm9XjdqNBriOI4UCgWpVqtRPMQGnH3oKQYcj8c2W8TZabbLnYMgMK1Ti8XC+IxHMSjcbreCo/Jhx4FI5iWcgMPhMLaYQPqM3wREMm9NJpOJAeJcYosJpM/4ORBFXALZ8mq1+rNl6l8tDwaDX1tm/CYgKkwxCcAdZo32NACEGwFofMajGLRnVwB6sBPnFX7yoXJHzqyIybQpPmT6jPOxM4ZP0jxsFBEAmDwHvqAdF5eSw4952HlUlKeNCsxMn/HIh5jrAPiG2OMJdvd/G0Lx+lU6nVZ4FgqXo7LZrMKXodCmQptqs9kofDkqk8koLDQ5kVA5cwzrC7WNe3CZBri3AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Persistent overflow icon example",
          "title": "Persistent overflow icon example",
          "src": "/static/e3123ed00716d657e99eef5a29891f76/fb070/data-table-usage-9.png",
          "srcSet": ["/static/e3123ed00716d657e99eef5a29891f76/d6747/data-table-usage-9.png 288w", "/static/e3123ed00716d657e99eef5a29891f76/09548/data-table-usage-9.png 576w", "/static/e3123ed00716d657e99eef5a29891f76/fb070/data-table-usage-9.png 1152w", "/static/e3123ed00716d657e99eef5a29891f76/c3e47/data-table-usage-9.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Overflow menu example</Caption>
    <h3 {...{
      "id": "expandable"
    }}>{`Expandable`}</h3>
    <p>{`The expandable data table is useful for presenting large amounts of data in a small space. Use the expanded section for suplementary information or data that needs additional query time.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "83.0163043478261%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAACPElEQVQ4y61UyapaQRDtb3DhN4j7kF+Ii4ArvymboH/gVwhyF08lrgKKijMKzvM8621v55wyLe8RAkLSUFR3VdfpU8O9Sv1e0WhURSIRFQ6HVSgUUolEQhlj1GazUbvd7iX570tAY7GYHObz+bfJZJIdj8dJiLNer53j8ejg0ivyBvkkQIFAQDRAsgAxg8FABKma8/lsPM8zr6zD4fBVgLCxDJME6ff71+l0qinD4VB3u109Go30bDbT1s49bb1ezwURd7FYGNi/CFCj0RCNYAdOUywWdafTMQgw1DibVqslZ8ue+3a7TZ+HOx4eoD0kQPl8XvR2u3Uul4sBqCZT1E/SZvBqtWJKZr/fi3BPG+56iPMYB/sDELSfgFprXtTYGxTZUC+XSwG2YFboQ5k8+DzWGucH4Ol0Es2O8mK1WmVthCHBms2mpMe0yIpCOwX3PQoBnwztQCINB+AE0BgfAQQDUygUTKVSMfV63ZTLZVOr1QzqLjamjHgBhH4AAvkJSAdryHRtWuwghYz4gGX3V4YI+gCIsdEEICiFDbANed8YCtn9wbBUKolGcZNME+leMeAaAZqas4gHyJrNEuGeNvhc3HH5EOyPOURdLNMfnHgW3XVdmX5qdphjwcWv5n6/y542+m63m5wR//hScrmcZfgdnfyJAX0DaBoM09QoQRps0mCVRpAIfbTRB4b0ZWH//PxL2LT/dfF39+EQj8dVMBiURvHMGfX7/SqVSsn5vWQyGeXz+dT1en3auH4Bxd6oB+XTy+MAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Expandable data table with one row expanded.",
          "title": "Expandable data table with one row expanded.",
          "src": "/static/eb1a84d71a5b0662a4ced332e8e6eb4e/fb070/data-table-usage-11.png",
          "srcSet": ["/static/eb1a84d71a5b0662a4ced332e8e6eb4e/d6747/data-table-usage-11.png 288w", "/static/eb1a84d71a5b0662a4ced332e8e6eb4e/09548/data-table-usage-11.png 576w", "/static/eb1a84d71a5b0662a4ced332e8e6eb4e/fb070/data-table-usage-11.png 1152w", "/static/eb1a84d71a5b0662a4ced332e8e6eb4e/c3e47/data-table-usage-11.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Expandable data table with one row expanded</Caption>
    <p>{`By default, the expand-all chevron is not shown. Keeping detailed information in expanded section saves user loading time by postponing some data queries until needed. Expanding all rows at once will typically negate this advantages of the expandable table. If additional load time is expected to display expanded information, use skeleton states instead of spinners.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "82.33695652173913%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAACDUlEQVQ4y6VUWYoiQRSsnJ5rzdxghL6OV/AIA/PrBTyBYNEKItqoIC4o7vu+lM96E5HUYg3NNMMkBPmy8mW8iJepjhMMVTV/IpfLmfV6bY7Ho9nv95/BcZ7JZrPZz8lkUhkOh4XRaORut1sXRC4S/4YCUAF+AS8JwvF4XAGJgkwR626309PppL7vKwfnZ3A8Hg87o/A7cr9GhM1m00BdYT6fa7/f90AoBGLp9XqCIoL9BAaDAfc9tESxfkNOrHA6nVKhC7taq9WEM75pp9PRarWqOGzXOGjBuNFoaL1eF7rCtxLIY0LP89h4V0RoVRDThh4OBwvGtB+Ca7aEubSPdQl5MWEmkzHn89ll5Xa7LZvNxh5iP7HW1WqltMaZIFlQTCgCF1JKXEo2mzWo7DKZ/QovpNvtarlcjmyyx3gNljwk5MVgTiqkZT6DoJoA9kCoin16UsWcyPKHCvls+O4ulwsV2EbzEAmpKlwHJDamUube73dLiDbFhPl83l4Kq8MaLfuIfajzF4uFzzUOReBegI8tp9NpA3UFPo9Wq+WhmqCHgmcjxWLRvjsWoiLOUC4kAzm65VHhW8IyEg0SKnz1tBD+EmhtuVwqXoBer1e7R7BvzGEc5L0D8S/ldrs56NM3fHyFvR+IUwRUpkCUQjEL7EfgfpD7CnwHjCVL/Ev854i4GABf2Idg/heEZyzXb1g9sMYxL/ofAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Expandabling all rows with skeleton states",
          "title": "Expandabling all rows with skeleton states",
          "src": "/static/14080956703cd9658e2aee5e140e3040/fb070/data-table-usage-12.png",
          "srcSet": ["/static/14080956703cd9658e2aee5e140e3040/d6747/data-table-usage-12.png 288w", "/static/14080956703cd9658e2aee5e140e3040/09548/data-table-usage-12.png 576w", "/static/14080956703cd9658e2aee5e140e3040/fb070/data-table-usage-12.png 1152w", "/static/14080956703cd9658e2aee5e140e3040/c3e47/data-table-usage-12.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">Expandabling all rows with skeleton states</Caption>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      